import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { aiApi } from '../services/aiApi';
import { useAIJobStatus } from './useAIJobStatus';

export function useAIImageAnalysis(boatId: string) {
  const [jobId, setJobId] = useState<string | undefined>();

  const trigger = useMutation({
    mutationFn: () => aiApi.analyzeImage(boatId),
    onSuccess: (data) => {
      setJobId(data.job_id);
    },
  });

  const jobStatus = useAIJobStatus(jobId);

  const reset = () => {
    setJobId(undefined);
  };

  return {
    trigger,
    jobStatus,
    jobId,
    reset,
    isActive: !!jobId && jobStatus.data?.status !== 'completed' && jobStatus.data?.status !== 'failed',
  };
}
